module.exports = __webpack_public_path__ + "resources/img/img-acra-point-02-m.7d2aefecf90d91332186fb34fa706216.png";